// extracted by mini-css-extract-plugin
export default {"phone_wrapper":"_styles_phone_wrapper__s7Pqg"};